// extracted by mini-css-extract-plugin
export var TabletAndHigher = "only screen and (min-width: 768px)";
export var root = "desktop-module--root--8cc63";